import React from "react";
import "../css/Faq.css"

const pdfDocuments = [
  { title: "Internet & Privacy", url: "PDF/M-Internet_Privacy_Policy(2014-12-01).docx.pdf" },
  { title: "Sales Terms", url: "PDF/M-Sales Terms (2018-09-10).docx.pdf" },
  { title: "Product Warranty", url: "PDF/M-Warranty (2024-05-06) (Rev. A).docx.pdf" },
  { title: "How do returns work?", url: "PDF/Form RMA Info Rev 2.pdf" },
];

const Faq = () => {
  return (
    <div className="faq-container">
      <h1>Frequently Asked Questions</h1>
      <div className="faq-grid">
        {pdfDocuments.map((doc, index) => (
          <div key={index} className="faq-card">
            <embed
              src={doc.url}
              type="application/pdf"
              className="pdf-preview"
              title={doc.title}
            />
            <p>{doc.title}</p>
            <a href={doc.url} download className="download-link">
              Download PDF
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
